<template>
  <RevDrawer
    before-title-class-names="flex-1 ml-24"
    :name="PLAN_COMPARISON_DRAWER"
    size="large"
    title="&#160;"
  >
    <template #beforeTitle>
      <h2 class="heading-2">{{ i18n(translations.title) }}</h2>
    </template>
    <template #body>
      <div class="overflow-hidden rounded-lg border border-static-default-low">
        <RevTable :collection :columns striped-rows transparent-header>
          <template #body-feature="{ item }">
            <span class="body-1-bold">{{ item.feature }}</span>
          </template>
        </RevTable>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevTable } from '@ds/components/Table'

import translations from './PlanComparisonDrawer.translations'
import { PLAN_COMPARISON_DRAWER } from './constants'

const i18n = useI18n()

const columns = computed(() => [
  { key: 'feature', label: '' },
  { key: 'visible', label: i18n(translations.colVisible) },
  { key: 'usMobile', label: i18n(translations.colUsMobile) },
  { key: 'noble', label: i18n(translations.colNoble) },
])

const collection = computed(() => [
  {
    id: 'monthlyPrice',
    feature: i18n(translations.rowMonthlyPrice),
    visible: i18n(translations.visibleMonthlyPrice),
    usMobile: i18n(translations.usMobileMonthlyPrice),
    noble: i18n(translations.nobleMonthlyPrice),
  },
  {
    id: 'backMarketExclusive',
    feature: i18n(translations.rowBackMarketExclusive),
    visible: i18n(translations.visibleBackMarketExclusive),
    usMobile: i18n(translations.usMobileBackMarketExclusive),
    noble: i18n(translations.nobleBackMarketExclusive),
  },
  {
    id: 'taxesAndFees',
    feature: i18n(translations.rowTaxesAndFees),
    visible: i18n(translations.visibleTaxesAndFees),
    usMobile: i18n(translations.usMobileTaxesAndFees),
    noble: i18n(translations.nobleTaxesAndFees),
  },
  {
    id: 'network',
    feature: i18n(translations.rowNetwork),
    visible: i18n(translations.visibleNetwork),
    usMobile: i18n(translations.usMobileNetwork),
    noble: i18n(translations.nobleNetwork),
  },
  {
    id: 'data',
    feature: i18n(translations.rowData),
    visible: i18n(translations.visibleData),
    usMobile: i18n(translations.usMobileData),
    noble: i18n(translations.nobleData),
  },
  {
    id: 'hotspot',
    feature: i18n(translations.rowHotspot),
    visible: i18n(translations.visibleHotspot),
    usMobile: i18n(translations.usMobileHotspot),
    noble: i18n(translations.nobleHotspot),
  },
  {
    id: 'videoStreaming',
    feature: i18n(translations.rowVideoStreaming),
    visible: i18n(translations.visibleVideoStreaming),
    usMobile: i18n(translations.usMobileVideoStreaming),
    noble: i18n(translations.nobleVideoStreaming),
  },
  {
    id: 'talkAndText',
    feature: i18n(translations.rowTalkAndText),
    visible: i18n(translations.visibleTalkAndText),
    usMobile: i18n(translations.usMobileTalkAndText),
    noble: i18n(translations.nobleTalkAndText),
  },
  {
    id: 'internationalTexting',
    feature: i18n(translations.rowInternationalTexting),
    visible: i18n(translations.visibleInternationalTexting),
    usMobile: i18n(translations.usMobileInternationalTexting),
    noble: i18n(translations.nobleInternationalTexting),
  },
  {
    id: 'internationalCalling',
    feature: i18n(translations.rowInternationalCalling),
    visible: i18n(translations.visibleInternationalCalling),
    usMobile: i18n(translations.usMobileInternationalCalling),
    noble: i18n(translations.nobleInternationalCalling),
  },
  {
    id: 'internationalData',
    feature: i18n(translations.rowInternationalData),
    visible: i18n(translations.visibleInternationalData),
    usMobile: i18n(translations.usMobileInternationalData),
    noble: i18n(translations.nobleInternationalData),
  },
  {
    id: 'noContract',
    feature: i18n(translations.rowNoContract),
    visible: i18n(translations.visibleNoContract),
    usMobile: i18n(translations.usMobileNoContract),
    noble: i18n(translations.nobleNoContract),
  },
  {
    id: 'standoutPerk',
    feature: i18n(translations.rowStandoutPerk),
    visible: i18n(translations.visibleStandoutPerk),
    usMobile: i18n(translations.usMobileStandoutPerk),
    noble: i18n(translations.nobleStandoutPerk),
  },
])
</script>
